import { z } from "zod";
import { type CommandSpec, Uuid } from "./assistant-catalog-types.js";

// Família Interpretação (action · safe · GESTOR). Cria um artefato de leitura
// (SimulationInterpretation); os FATOS são computados pela plataforma, a `narrative` (opcional) é
// enriquecimento do modelo — sanitizada + redação de PII no service. Tier safe: cliente
// auto-confirma sem card (não muda estado operacional, idempotente por conteúdo).
const Narrative = z.string().max(4000).optional();

export const INTERPRETATION_COMMANDS: readonly CommandSpec[] = [
  {
    name: "simulation.interpret",
    kind: "action",
    riskTier: "safe",
    minRole: "GESTOR",
    description:
      "Interpreta o resultado de uma simulação (veredito, comparação, gargalo, confiança, próximo passo) e abre o painel.",
    argsSchema: z.object({ simulationId: Uuid, narrative: Narrative }).strict(),
  },
  {
    name: "simulation.interpretComparison",
    kind: "action",
    riskTier: "safe",
    minRole: "GESTOR",
    description: "Interpreta a comparação entre duas simulações e abre o painel.",
    argsSchema: z.object({ a: Uuid, b: Uuid, narrative: Narrative }).strict(),
  },
  {
    name: "simulation.interpretBatch",
    kind: "action",
    riskTier: "safe",
    minRole: "GESTOR",
    description:
      "Interpreta um lote de sugestões automáticas (candidato vencedor, por que venceu, o que aplicar) e abre o painel.",
    argsSchema: z.object({ batchId: Uuid, narrative: Narrative }).strict(),
  },
];
